import { useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'

import SimpleTable from '../simple-table'

const columns = [
  {
    field: 'quantity',
    headerName: 'Quantity',
    sortable: false,
    align: 'center',
  },
  {
    field: 'name',
    headerName: 'Item',
    flex: 1,
    sortable: false,
  },
  {
    field: 'sku',
    headerName: 'SKU',
    flex: 1,
    sortable: false,
  },
] satisfies GridColDef[]

const OrderItemList = ({ orderItems }: { orderItems: IOrderDetail['items'] }) => {
  const rows = useMemo(
    () =>
      (orderItems ?? []).map((item, idx) => ({
        id: idx,
        ...item,
      })),
    [orderItems]
  )

  return <SimpleTable columns={columns} rows={rows} pagination={false} />
}

export default OrderItemList
